import { render } from "./EditForm.vue?vue&type=template&id=b7b7d7d2&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"

import "./EditForm.vue?vue&type=style&index=0&id=b7b7d7d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b7d7d2"]])

export default __exports__